
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/nda",
      function () {
        return require("private-next-pages/[locale]/nda/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/nda"])
      });
    }
  